import './bootstrap';

// Import everything from autoload
import './autoload/_lazysizes'
import './autoload/_smartresize'
import './autoload/_slick-carousel'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

/** Populate Router instance with DOM routes */
const routes = new Router({
	// All pages
	common
});

// Load Events
$(document).ready(() => routes.loadEvents());
